import { useShoppingCart, formatCurrencyString } from 'use-shopping-cart'
export function parseCurrencyString(price, currency, language) {
  return formatCurrencyString({
    value: 100 * parseInt(price),
    currency: currency || 'AUD',
    language: language || 'en-AU'
  })
}
